/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowAssignmentGroup {
    getFixupPrototypeFunction() { return ServiceNowAssignmentGroup.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowAssignmentGroup>): ServiceNowAssignmentGroup {
        let obj = Object.assign(new ServiceNowAssignmentGroup(), model);
        ServiceNowAssignmentGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowAssignmentGroup>): ServiceNowAssignmentGroup {
        if (!model) return null;
        return ServiceNowAssignmentGroup.newInstance(<ServiceNowAssignmentGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowAssignmentGroup) {
        if (!obj) return;

        models.ServiceNowAssignmentGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowAssignmentGroup): boolean {
        Object.setPrototypeOf(obj, ServiceNowAssignmentGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter) {
            models.ServiceNowAssignmentGroupFilter.fixupPrototype(this.filter);
        }
    }

    /**
     * Assignment Group Name
     */
    group_name: string;

    filter: models.ServiceNowAssignmentGroupFilter;

}
